<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :esg-subscription="esgSubscription"
    :prices-assessment-subscription="subscription"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :esg-subscription="esgSubscription"
      :prices-assessment-subscription="subscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  SYNTHETIC_GRAPHITE,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_SYNTHETIC_GRAPHITE,
  SUBSCRIPTION_ESG_SYNTHETIC_GRAPHITE,
  SUBSCRIPTION_FORECASTS_SYNTHETIC_GRAPHITE,
} from '~/constants/services/constants'
import syntheticGraphiteData from '~/constants/data-reports/synthetic-graphite'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(SYNTHETIC_GRAPHITE)
const productData = ref(syntheticGraphiteData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_SYNTHETIC_GRAPHITE)
const esgSubscription = ref(SUBSCRIPTION_ESG_SYNTHETIC_GRAPHITE)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_SYNTHETIC_GRAPHITE)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${SYNTHETIC_GRAPHITE.name} Data and Reports`,
})
useHead(seo)
</script>
